import React, { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import Toast from './Toast';

const FeatureSettings = ({ mySettings, organization }) => {  // destructure props here
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
  const [rideEnabled, setRideEnabled] = useState('no');
  const API_URL = process.env.REACT_APP_API_URL || 'http://45.194.3.128:4000/api/admin/';
  useEffect(() => {
    if (mySettings && mySettings.length > 0) {
      setRideEnabled(mySettings[0].ride || "no");

    }
  }, [mySettings]);


  const SaveApprovalSettings = async () => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}update-approval-settings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        approvals: {
          ride: {
            approval: rideEnabled,
          }
        },
        org_id: organization
      }),
    });

     const data = await response.json();

        if (!response.ok || data.success === false) {

              if (data.message === 'Invalid token') {
                localStorage.removeItem('token');
                window.location.href = '/login';
                return;
              }

                setToast({ open: true, message: `Error saving settings: ${data.message}`, severity: "error" });
        }
        
      setToast({ open: true, message: "Settings saved successfully!", severity: "success" });
      setTimeout(() => window.location.reload(), 1000);
   
  };

  return (
    <section style={{
      background: "rgba(255, 255, 255, 0.05)",
      backdropFilter: "blur(20px)",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      borderRadius: 12,
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
      padding: 24,
      color: "#FFFFFF",
      gap: 24
    }}>
      <div style={{ marginTop: 24, borderBottom: "1px solid #e5e7eb", paddingBottom: 16 }}>
        <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 12 }}>Ride Module</div>
        <div style={{ marginBottom: 16 }}>

          <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 10 }}>
            <span style={{ fontWeight: 500, marginRight: 8 }} data-testid="ride-status">
              {rideEnabled === "yes" ? 'Enabled' : 'Disabled'}
            </span>
            <label className="switch">
              <input type="checkbox"
                checked={rideEnabled === "yes"}
                onChange={e => setRideEnabled(e.target.checked ? 'yes' : 'no')}
                aria-label="Ride toggle"

              />
              <span className="slider"></span>
            </label>
          </div>

        </div>




      </div>












      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
        <Button
          style={{
            backgroundColor: "#c0c5cfff",
            color: "#fff",
            padding: "8px 16px",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontWeight: 500,
          }}
          onClick={() => window.location.reload()}
        >
          Cancel
        </Button>

        <Button variant="contained" sx={{ background: "#177373" }} onClick={SaveApprovalSettings}>
          Save Settings
        </Button>
      </Box>
      <Toast toast={toast} setToast={setToast} />
    </section>
  );


}
export default FeatureSettings;